import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rounddecimals'
})
export class RounddecimalsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return Math.floor(value);
  }

}
